import dayjs from 'dayjs';

window.jzApp = {

  date: (date: string, name: string, format: string = 'YYYY-MM-DD') => ({
    [name]: dayjs(date).format(format),
  }),
};
